const PropTypes = require('prop-types');

//@vendors
const React = require("react");

//commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const {
    MYPROFILE_BROKER_PLANS_URL,
    MYPROFILE_BROKER_URL,
    BROKER_MYPROFILE_MYWALLET_URL
} = require('constants/index');

const BREADCRUMB = [
    {
        text: formatText('breadcrumb-brokerMyWallet'),
        url: MYPROFILE_BROKER_URL
    },
    {
        text: formatText('plans-plans'),
        url: MYPROFILE_BROKER_PLANS_URL
    },
    {
        text: formatText('pensionPlanPeriodicalContribution-breadcrumbThirdLink'),
        url: ''
    }
];

class BrokerPensionPlanPeriodicalContributionHeader extends React.Component {

    render() {
        const { hasPlanPeriodicalContribution } = this.props;
        let link;

        if (!hasPlanPeriodicalContribution) {
            link = (
                <OKLink
                    inverse={true}
                    modifier="complementary"
                    to={BROKER_MYPROFILE_MYWALLET_URL}
                >
                    <FormattedText value="pensionPlanPeriodicalContribution-headerLink" />
                </OKLink>
            );
        }

        return (
            <div className="row">
                <OKCover size="higher-small" section="broker" customClass="col-xs-12">
                    <BrokerTruncatedBreadcrumb
                        titleKey="pensionPlanPeriodicalContribution-headerTitle"
                        subtitleLeft={formatText('pensionPlanPeriodicalContribution-headerSecondTitle')}
                        breadcrumbConfig={BREADCRUMB}
                    >
                        {link}
                    </BrokerTruncatedBreadcrumb>
                </OKCover>
            </div>
        );
    }
}

BrokerPensionPlanPeriodicalContributionHeader.propTypes = {
    hasPlanPeriodicalContribution: PropTypes.bool
};

module.exports = BrokerPensionPlanPeriodicalContributionHeader;
